import { escapeRegExp } from "lodash";
import classNames from "classnames";
import React from "react";
import ReactDOMServer from "react-dom/server";
import styles from "./highlighterSpan.css";

type Variant = "alert" | "bold";

interface Props {
  highlightWord?: string | null;
  text: string;
  variant?: Variant;
  textClassName?: string;
}

export const HighlighterSpan = ({
  highlightWord,
  text,
  textClassName,
  variant = "bold"
}: Props) => {
  const getHighlightStyles = () => {
    switch (variant) {
      case "alert":
        return styles.alert;
      case "bold":
      default:
        return styles.bold;
    }
  };

  const processText = (word: string) => {
    return text.replace(new RegExp(escapeRegExp(word), "ig"), (found) =>
      ReactDOMServer.renderToString(renderWordHighlited(found))
    );
  };

  const processEmptyLines = () => text.split("\n").join("\n\u200b");

  const renderWordHighlited = (word: string) => {
    return <span className={classNames(textClassName, getHighlightStyles())}>{word}</span>;
  };

  const renderWordsHighlighted = (word: string) => {
    return (
      <span className={textClassName} dangerouslySetInnerHTML={{ __html: processText(word) }} />
    );
  };

  const renderNormal = () => {
    return <span className={textClassName}>{processEmptyLines()}</span>;
  };

  return highlightWord ? renderWordsHighlighted(highlightWord) : renderNormal();
};
